import { Modal } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useHistory } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../../hooks/useUser";
import useGeneralContext from "../../context/GeneralContext";
import { IoSparklesOutline } from "react-icons/io5";
import GradientText from "../Logo";

const StartTutorialDialog = () => {
  const { setTourStart } = useGeneralContext();

  let history = useHistory();
  const { reloadUserCachedDetails } = useUser();

  const handleCloseModal = (run?: string) => {
    if (run === "true") {
      setTourStart(true);
    }

    history.push("/dashboard");
  };

  //Reload the userDetails cache.
  useEffect(() => {
    let fetchData = async () => {
      await reloadUserCachedDetails();
    };
    fetchData();
  }, [reloadUserCachedDetails]);

  return (
    <Modal size="xl" fullscreen={true} show={true} centered>
      <div className="row pd-7">
        <div
          className="col-12"
          style={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <AiOutlineCloseCircle
            color="var(--text-1)"
            cursor={"pointer"}
            size={25}
            onClick={() => {
              return handleCloseModal();
            }}
          />
        </div>
      </div>
      <div className="az-content-body pd-l-20 pd-r-20 pd-b-20 d-flex flex-column">
        <div className="d-flex justify-content-center">
          <IoSparklesOutline
            style={{ color: "var(--primary-blue)" }}
            size={55}
          />
        </div>
        <h1 className="text-center">
          Olá, sou a <GradientText text={"Lucy."} />
        </h1>
        <p className="tx-15 text-center tx-light">
          Sou a inteligência artificial evolutiva por trás da FatoresAI, sou
          responsável por te entregar as análises mais precisas, e serei sua
          Parceira N°1 durante sua jornada de investimentos!
        </p>
        <p className="mg-b-20 tx-16 text-center tx-semibold">
          Aceita um tutorial onde eu te ensino a utilizar a plataforma?
        </p>

        <div className="d-flex gap-8 justify-content-center align-items-center mg-t-20">
          <button
            className="btn font-weight-bold rounded-md"
            style={{ color: "var(--text-1)", backgroundColor: "var(--bg-8)" }}
            onClick={() => {
              return handleCloseModal();
            }}
          >
            Pular tutorial
          </button>
          <button
            className="btn btn-primary font-weight-bold rounded-md"
            onClick={() => {
              return handleCloseModal("true");
            }}
          >
            Aceitar tutorial
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default StartTutorialDialog;
